export const topSlider = () => {
  $(function () {
    $(".js-mv-slider")
      .on("init", function () {
        $('.slick-slide[data-slick-index="0"]').addClass("is-slide-active");
      })
      .slick({
        dots: false,
        infinite: true,

        arrows: false, // 矢印
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 4000,
        autoplaySpeed: 8000,
        fade: true,
        // autoplay: false,
        autoplay: true,
        pauseOnFocus: false, //フォーカスで一時停止を無効
        pauseOnHover: false, //マウスホバーで一時停止を無効

        // responsive: [
        //   {
        //     breakpoint: 768, // 768pxの画面幅以下の場合
        //     settings: {
        //       dots: true,
        //       appendDots: $('#js-mv-sp-dots'),
        //     },
        //   },
        //   // その他のブレークポイントに対しても設定を追加可能
        // ],
      })
      .on({
        beforeChange: function (event, slick, currentSlide, nextSlide) {
          $(".slick-slide", this).eq(currentSlide).addClass("remove-animation");
          $(".slick-slide", this).eq(nextSlide).addClass("is-slide-active");
        },
        afterChange: function () {
          $(".remove-animation", this).removeClass(
            "remove-animation is-slide-active"
          );
        },
      });
  });
};
